var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerySatisfied(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99 0C4.468.006-.004 4.485 0 10.007S4.482 20.002 10.003 20 20 15.522 20 10A9.99 9.99 0 0 0 9.99 0zM10 18a8 8 0 1 1 0-16 8 8 0 1 1 0 16zm1-10.06L12.06 9l1.06-1.06L14.18 9l1.06-1.06-2.12-2.12zm-4.12 0L7.94 9 9 7.94 6.88 5.82 4.76 7.94 5.82 9l1.06-1.06zM10 15.5a5.5 5.5 0 0 0 5.11-3.5H4.89A5.5 5.5 0 0 0 10 15.5z",
    fill: "#3bb273"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerySatisfied);
export default __webpack_public_path__ + "static/media/very_satisfied.e9d993b0.svg";
export { ForwardRef as ReactComponent };